import {Component, ElementRef, EventEmitter, Inject, OnInit, ViewChild} from '@angular/core';
import {NetworkApiService} from '../../../services/api/network/online/network/network-api.service';
import {DIALOG_CONFIG, GeneralService} from 'ac-infra';
import _ from 'lodash';
import {
  ChooseTopologyItemApiService
} from '../../../utils/choose-topology-item/services/choose-topology-item-api/choose-topology-item-api.service';
import {
  DataItemToVisualsMappersService
} from '../../../network/services/map/data-item-to-visuals-mappers/data-item-to-visuals-mappers.service';
import {
  ChooseTopologyDataItemToVisualsMappersService
} from '../../../utils/choose-topology-item/services/choose-topology-data-item-to-visuals-mappers/choose-topology-data-item-to-visuals-mappers.service';
import {
  ChooseTopologyItemContextMenuService
} from '../../../utils/choose-topology-item/services/choose-topology-item-context-menu/choose-topology-item-context-menu.service';
import {ContextMenuComponent} from '@perfectmemory/ngx-contextmenu';


@Component({
  selector: 'calls-dialog',
  templateUrl: './calls-dialog.component.html',
  styleUrls: ['./calls-dialog.component.scss']
})
export class CallsDialogComponent implements OnInit {

  details: any;
  displayedColumns = ['pathName', 'status'];
  showMorePathInfo: boolean;
  selectedPath: any = {};
  onApply = new EventEmitter();
  onCancel = new EventEmitter();

  savedMapConfigurations: any;
  contextMenuData: any;
  diagramApi: any;
  showNetworkDiagram: boolean;

  showUnselectedRules = false;
  lastSelectedPathDisplayName = null;

  pathsList = [];

  @ViewChild(ContextMenuComponent, {static: false}) public callsMapMenu: ContextMenuComponent;

  @ViewChild('pathSummaryContent', {static: false}) private pathSummaryContent: ElementRef;

  constructor(private networkApiService: NetworkApiService,
              private generalService: GeneralService,
              @Inject(DIALOG_CONFIG) private dialogConfig,
              private chooseTopologyItemApiService: ChooseTopologyItemApiService,
              private mainMapDataItemToVisualsMappersService: DataItemToVisualsMappersService,
              private dataItemToVisualsMappersService: ChooseTopologyDataItemToVisualsMappersService,
              private contextMenuService: ChooseTopologyItemContextMenuService) {
  }

  ngOnInit(): void {
    this.showMorePathInfo = false;
    this.details = this.dialogConfig.dialogData.details;
    this.initializeMapConfigurations();
    this.showNetworkDiagram = true;
  }

  isManipulationExist(): boolean {
    return !_.isNil(this.selectedPath.manipulations) && this.selectedPath.manipulations.length > 0;
  }

  toggeleMoreInfo(): void {
    this.showMorePathInfo = !this.showMorePathInfo;
  }

  getVoiceDuration(voiceDuration): string {
    if (!voiceDuration || voiceDuration < 0) {
      return 'N/A';
    } else {
      return voiceDuration / 1000 + ' Sec';
    }
  }

  updatePathDetails(path): void {
    this.setPathSelection(path);
    this.drawCurrentPath(path);
    this.showMorePathInfo = false;
  }

  drawCurrentPath(path): void {
    if (path.unselectedRule) {
      this.diagramApi.clearPath();
      return;
    }

    const pathToDraw = this.preparePathForDraw(path);

    if (pathToDraw) {
      this.diagramApi.drawPath([{
        color: 'purple',
        nodes: pathToDraw.nodes,
        edges: pathToDraw.edges
      }]);
    } else {
      this.diagramApi.clearPath();
    }
  }

  preparePathForDraw(path): any {
    const pathObj = {nodes: [], edges: []};

    pathObj.nodes = this.prepareNodesToDraw(path);
    pathObj.edges = this.prepareEdgesToDraw(path);

    return pathObj;
  }


  prepareNodesToDraw(path): any {
    const nodes = [];

    nodes.push('node_' + path.srcNode);

    if (path.edges !== null) {
      path.edges.forEach((edge) => {
        nodes.push('node_' + edge.connDestNode);
      });
    }

    if (path.destNode !== null && nodes.indexOf('node_' + path.destNode) === -1) {
      nodes.push('node_' + path.destNode);
    }
    return nodes;
  }

  prepareEdgesToDraw(path): any {
    const edges = [];

    if (path.srcPeerConnection) {
      edges.push('peerConnection_' + path.srcPeerConnection);
    }

    if (path.srcConnection) {
      edges.push('connection_' + path.srcConnection);
    }

    if (path.edges !== null) {
      path.edges.forEach((edge) => {
        edges.push('connection_' + edge.connectionId);
      });
    }

    if (path.srcPeerConnection !== path.destPeerConnection) {
      edges.push('peerConnection_' + path.destPeerConnection);
    }

    return edges;
  }

  setPathSelection(path): void {
    this.selectedPath = path;
  }

  getManipulationBeforeRouting(manipulations): any {
    return manipulations.filter(manipulation => manipulation.manipulationType === 'Before route');
  }

  getManipulationDuringRouting(manipulations): any {
    return manipulations.filter(manipulation => manipulation.manipulationType === 'During route');
  }

  scrollToBottom(): void {
    setTimeout(() => {
      this.pathSummaryContent.nativeElement.scroll({
        top: this.pathSummaryContent.nativeElement.scrollHeight,
        behavior: 'smooth'
      });
    }, 200);
  }

  initializeMapConfigurations(): void {
    const conf = localStorage.getItem('MapConfigurations_online');
    this.savedMapConfigurations = conf ? JSON.parse(conf) : {};
    if (!!this.savedMapConfigurations.labelOptions) {
      this.dataItemToVisualsMappersService.setLabelOptions(this.savedMapConfigurations.labelOptions);
    }
  }

  initializeDiagramWithData(): void {
    Promise.all([this.chooseTopologyItemApiService.getDataForShapes(undefined),
      this.chooseTopologyItemApiService.getDataForConnections(undefined), this.networkApiService.getClusters().toPromise()])
      .then(data => {
        this.diagramApi.setData(data[0], data[1], data[2], true);
      });
  }

  getClusteredEdgePropertiesByEdges = (edgesInCluster) => {
    return this.mainMapDataItemToVisualsMappersService.getClusteredEdgeProperties(edgesInCluster);
  }

  getClusteredNodePropertiesByNodes = (nodesInCluster) => {
    return this.mainMapDataItemToVisualsMappersService.getClusteredNodeProperties(nodesInCluster);
  }

  onContextMenu($event): void {
    const rightClickedElement = $event.contextMenuObject.element;
    this.contextMenuData = this.contextMenuService.prepareContextMenuActions(this.diagramApi, rightClickedElement);
  }

  onDiagramReady(diagramApiLocal): void {
    this.diagramApi = diagramApiLocal;
    // if (this.formSettings.dialogReady) {
    this.initializeDiagramWithData();
    // }
    if (this.details.cdrSessionPathList !== null && this.details.cdrSessionPathList.length > 0) {
      this.pathsList = this.details.cdrSessionPathList.filter(path => !path.unselectedRule);
      this.updatePathDetails(this.pathsList[0]);
      this.lastSelectedPathDisplayName = this.pathsList[0].displayName;
    }
  }

  bringIntoView(): void {
    this.diagramApi.fit();
  }

  zoomIn(): void {
    this.diagramApi.zoomIn();
  }

  zoomOut(): void {
    this.diagramApi.zoomOut();
  }

  showUnselectedRulesChange(showUnselectedRules: boolean): void {
    this.pathsList = showUnselectedRules ? this.details.cdrSessionPathList :
      this.details.cdrSessionPathList.filter(path => !path.unselectedRule);

    const lastSelectedPath = this.lastSelectedPathDisplayName &&
      this.pathsList.find(path => path.displayName === this.lastSelectedPathDisplayName);
    const pathToSelect = lastSelectedPath ? lastSelectedPath : this.pathsList[0];

    this.updatePathDetails(pathToSelect);
  }
}
